/**
 * 翻译函数 V2 - 根据语言环境返回对应文本
 * 用于 TranslateConfig Context 方案
 *
 * @param categoryOptions - 选项数组
 * @param getLocale - 获取当前语言的函数
 * @returns 翻译函数，接收 key 返回对应语言的文本
 */
export function categoryTranslateV2(
  categoryOptions: { text: string; textCn: string; value: string }[],
  getLocale: () => string = () => 'en',
): (key: string) => string {
  const categoryMap: Record<string, { text: string; textCn: string }> =
    categoryOptions.reduce(
      (acc, cur) => {
        const { value, text, textCn } = cur;
        const key = value.toLowerCase();
        return {
          ...acc,
          [key]: { text, textCn },
        };
      },
      {
        other: {
          text: 'Others',
          textCn: '其他',
        },
        others: {
          text: 'Others',
          textCn: '其他',
        },
      },
    );

  return (value: string) => {
    const key = value?.toLowerCase() || '';
    const result = categoryMap[key];
    if (!result) return value || '-';

    const locale = getLocale();
    const isZh = locale === 'zh' || locale === 'zh-CN';

    return isZh ? result.textCn : result.text;
  };
}
 